import apiClient from '@/utils/axios'
import {apiEndPoints} from '@/utils/constant'

const {ANSWER_URL, COMMENT_URL} = apiEndPoints

const comment = {
  async postComment(commentData, answerId) {
    const response = await apiClient.post(`${ANSWER_URL}/${answerId}/${COMMENT_URL}`, {
      comment: commentData,
    })
    return response
  },

  async postReply(commentData, commentId) {
    const response = await apiClient.post(`${COMMENT_URL}/${commentId}/${COMMENT_URL}`, {
      comment: commentData,
    })
    return response.data
  },

  async getReply(commentId) {
    const response = await apiClient.get(`${COMMENT_URL}/${commentId}`)
    return response.data
  },
}

export {comment}
